import { Injectable } from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { from, map, catchError, of, Observable } from 'rxjs';
import { functions } from '../app.component';

export interface PostcodeResponse {
  street: string;
  city: string;
  postcode: string;
  houseNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class PostcodeApiService {
  private functions = functions;

  getAddress(postcode: string, houseNumber: string): Observable<PostcodeResponse | null> {
    const httpGetAddress = httpsCallable(this.functions, 'httpGetAddressWithApi');

    // Clean inputs
    const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase();
    const cleanHouseNumber = houseNumber.toString().trim();

    return from(httpGetAddress({ postal: cleanPostcode, houseNumber: cleanHouseNumber })).pipe(
      map((result: any) => {
        if (result.data && result.data.street) {
          return result.data as PostcodeResponse;
        }
        return null;
      }),
      catchError((error) => {
        console.error('Postcode lookup error:', error);
        return of(null);
      }),
    );
  }
}
